export default function hiveStateManager() {
  let instance = null;
  function createInstance() {
    let hives = [];
    let homeYard1Positions = [
      { pos: { x: 2, y: 4 }, occupied: false, hive: null },
      { pos: { x: 4, y: 4 }, occupied: false, hive: null },
      { pos: { x: 6, y: 4 }, occupied: false, hive: null },
      { pos: { x: 8, y: 4 }, occupied: false, hive: null },

      { pos: { x: 2, y: 8 }, occupied: false, hive: null },
      { pos: { x: 4, y: 8 }, occupied: false, hive: null },
      { pos: { x: 6, y: 8 }, occupied: false, hive: null },
      { pos: { x: 8, y: 8 }, occupied: false, hive: null },

      { pos: { x: 2, y: 12 }, occupied: false, hive: null },
      { pos: { x: 4, y: 12 }, occupied: false, hive: null },
      { pos: { x: 6, y: 12 }, occupied: false, hive: null },
      { pos: { x: 8, y: 12 }, occupied: false, hive: null },
    ];
    return {
      setHives: (value) => {
        console.log("setting hive state: ", value);
        hives = value;
      },
      setHomeYard1Positions: (value) => {
        homeYard1Positions = value;
      },
      getHomeYard1Positions: () => {
        return homeYard1Positions;
      },
      getHives: () => {
        return hives;
      },
    };
  }
  return {
    getInstance: () => {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    },
  };
}
